import { EScene as t, ETheme as e } from "../../../../common/type.mjs";
import { ballonStyle as a } from "../reolink/ballon.mjs";
import { buttonStyle as o } from "../reolink/button.mjs";
import { checkboxStyle as l } from "../reolink/checkbox.mjs";
import { inputStyle as u, measureInputStyle as T } from "../reolink/input.mjs";
import { textAreaStyle as h } from "../reolink/textArea.mjs";
import { linkStyle as p, animateStyle as s } from "../reolink/link.mjs";
import { popupStyle as i } from "../reolink/popup.mjs";
import { radioGroupStyle as S } from "../reolink/radioGroup.mjs";
import { selectStyle as y } from "../reolink/select.mjs";
import { tabsStyle as L } from "../reolink/tabs.mjs";
import { tagStyle as A } from "../reolink/tag.mjs";
import { uploadStyle as d, uploadListStyle as I } from "../reolink/upload.mjs";
import { draggedUploadStyle as K, draggedUploadListStyle as R } from "../reolink/draggedUpload.mjs";
import { formStyle as g } from "../reolink/form.mjs";
import { messageStyle as n } from "../reolink/message.mjs";
import { counterStyle as $ } from "../reolink/counter.mjs";
import { ballonStyle as G, lightTheme as z, darkTheme as B } from "../camovue/ballon.mjs";
import { buttonStyle as f, lightTheme as F, darkTheme as J } from "../camovue/button.mjs";
import { checkboxStyle as D, lightTheme as P, darkTheme as Q } from "../camovue/checkbox.mjs";
import { inputStyle as m, lightTheme as v, darkTheme as w, measureInputLightStyle as W, measureInputDarkStyle as X } from "../camovue/input.mjs";
import { textAreaStyle as E, textAreaLightTheme as Y, textAreaDarkTheme as Z } from "../camovue/textArea.mjs";
import { linkStyle as c, animateStyle as H, lightTheme as _, darkTheme as ee } from "../camovue/link.mjs";
import { lightTheme as te, popupStyle as M, darkTheme as re } from "../camovue/popup.mjs";
import { radioGroupStyle as O, lightTheme as ue, darkTheme as me } from "../camovue/radioGroup.mjs";
import { selectStyle as k, lightTheme as ae, darkTheme as oe } from "../camovue/select.mjs";
import { tabsStyle as U, lightTheme as le, darkTheme as Te } from "../camovue/tabs.mjs";
import { lightTheme as he, tagStyle as b, darkTheme as pe } from "../camovue/tag.mjs";
import { lightTheme as se, uploadStyle as C, uploadListStyle as N, darkTheme as ie } from "../camovue/upload.mjs";
import { lightTheme as Se, draggedUploadStyle as V, draggedUploadListStyle as x, darkTheme as ye } from "../camovue/draggedUpload.mjs";
import { formStyle as r } from "../camovue/form.mjs";
import { messageStyle as j } from "../camovue/message.mjs";
import { counterStyle as q } from "../camovue/counter.mjs";
const Qe = {
  [t.REOLINK]: {
    [e.LIGHT]: { [a]: !0 },
    [e.DARK]: { [a]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [G]: !0,
      [z]: !0
    },
    [e.DARK]: {
      [G]: !0,
      [B]: !0
    }
  }
}, We = {
  [t.REOLINK]: {
    [e.LIGHT]: { [o]: !0 },
    [e.DARK]: { [o]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [f]: !0,
      [F]: !0
    },
    [e.DARK]: {
      [f]: !0,
      [J]: !0
    }
  }
}, Xe = {
  [t.REOLINK]: {
    [e.LIGHT]: { [l]: !0 },
    [e.DARK]: { [l]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [D]: !0,
      [P]: !0
    },
    [e.DARK]: {
      [D]: !0,
      [Q]: !0
    }
  }
}, Ye = {
  [t.REOLINK]: {
    [e.LIGHT]: { [u]: !0 },
    [e.DARK]: { [u]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [m]: !0,
      [v]: !0
    },
    [e.DARK]: {
      [m]: !0,
      [w]: !0
    }
  }
}, Ze = {
  [t.REOLINK]: {
    [e.LIGHT]: { [T]: !0 },
    [e.DARK]: { [T]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [W]: !0
    },
    [e.DARK]: {
      [X]: !0
    }
  }
}, _e = {
  [t.REOLINK]: {
    [e.LIGHT]: {
      [h]: !0,
      [u]: !0
    },
    [e.DARK]: {
      [h]: !0,
      [u]: !0
    }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [m]: !0,
      [v]: !0,
      [E]: !0,
      [Y]: !0
    },
    [e.DARK]: {
      [m]: !0,
      [w]: !0,
      [E]: !0,
      [Z]: !0
    }
  }
}, et = {
  [t.REOLINK]: {
    [e.LIGHT]: {
      [p]: !0,
      [s]: !0
    },
    [e.DARK]: {
      [p]: !0,
      [s]: !0
    }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [c]: !0,
      [H]: !0,
      [_]: !0
    },
    [e.DARK]: {
      [c]: !0,
      [H]: !0,
      [ee]: !0
    }
  }
}, tt = {
  [t.REOLINK]: {
    [e.LIGHT]: { [i]: !0 },
    [e.DARK]: { [i]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [te]: !0,
      [M]: !0
    },
    [e.DARK]: {
      [re]: !0,
      [M]: !0
    }
  }
}, rt = {
  [t.REOLINK]: {
    [e.LIGHT]: { [S]: !0 },
    [e.DARK]: { [S]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [O]: !0,
      [ue]: !0
    },
    [e.DARK]: {
      [O]: !0,
      [me]: !0
    }
  }
}, ut = {
  [t.REOLINK]: {
    [e.LIGHT]: { [y]: !0 },
    [e.DARK]: { [y]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [k]: !0,
      [ae]: !0
    },
    [e.DARK]: {
      [k]: !0,
      [oe]: !0
    }
  }
}, mt = {
  [t.REOLINK]: {
    [e.LIGHT]: { [L]: !0 },
    [e.DARK]: { [L]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [U]: !0,
      [le]: !0
    },
    [e.DARK]: {
      [U]: !0,
      [Te]: !0
    }
  }
}, at = {
  [t.REOLINK]: {
    [e.LIGHT]: { [A]: !0 },
    [e.DARK]: { [A]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [he]: !0,
      [b]: !0
    },
    [e.DARK]: {
      [pe]: !0,
      [b]: !0
    }
  }
}, ot = {
  [t.REOLINK]: {
    [e.LIGHT]: {
      [d]: !0,
      [I]: !0
    },
    [e.DARK]: {
      [d]: !0,
      [I]: !0
    }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [se]: !0,
      [C]: !0,
      [N]: !0
    },
    [e.DARK]: {
      [ie]: !0,
      [C]: !0,
      [N]: !0
    }
  }
}, lt = {
  [t.REOLINK]: {
    [e.LIGHT]: {
      [K]: !0,
      [R]: !0
    },
    [e.DARK]: {
      [K]: !0,
      [R]: !0
    }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [Se]: !0,
      [V]: !0,
      [x]: !0
    },
    [e.DARK]: {
      [ye]: !0,
      [V]: !0,
      [x]: !0
    }
  }
}, Tt = {
  [t.REOLINK]: {
    [e.LIGHT]: { [g]: !0 },
    [e.DARK]: { [g]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [r]: !0,
      [r]: !0
    },
    [e.DARK]: {
      [r]: !0,
      [r]: !0
    }
  }
}, ht = {
  [t.REOLINK]: {
    [e.LIGHT]: { [n]: !0 },
    [e.DARK]: { [n]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: {
      [j]: !0
    },
    [e.DARK]: {
      [j]: !0
    }
  }
}, pt = {
  [t.REOLINK]: {
    [e.LIGHT]: { [$]: !0 },
    [e.DARK]: { [$]: !0 }
  },
  [t.CAMOVUE]: {
    [e.LIGHT]: { [q]: !0 },
    [e.DARK]: { [q]: !0 }
  }
};
export {
  Qe as balloonThemeMap,
  We as buttonThemeMap,
  Xe as checkboxThemeMap,
  pt as counterThemeMap,
  lt as draggedUploadThemeMap,
  Tt as formThemeMap,
  Ye as inputThemeMap,
  et as linkThemeMap,
  Ze as measureInputThemeMap,
  ht as messageThemeMap,
  tt as popupThemeMap,
  rt as radioGroupThemeMap,
  ut as selectThemeMap,
  mt as tabsThemeMap,
  at as tagsThemeMap,
  _e as textAreaThemeMap,
  ot as uploadThemeMap
};
//# sourceMappingURL=templateMap.mjs.map
